export const classes = {
  cell: 'cursor-pointer text-sm text-grey-7 font-medium py-4 bg-grey-1 border-b border-grey-3',
  content: 'inline-flex items-center',
  label: 'cursor-pointer select-none',
  arrow: 'cursor-pointer ml-1',
};
